import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Landing from './Pages/Landing/Landing';
import About from './Pages/About/About';
import Inspiration from './Pages/Inspiration/Inspiration';
import Business from './Pages/Business/Business';
import CustomerService from './Pages/CustomerService/CustomerService';
import Cart from './Pages/Cart/Cart';
import Dashboard from './Pages/Dashboard/Dashboard';

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/inspiration" element={<Inspiration />} />
        <Route path="/business" element={<Business />} />
        <Route path="/customer-service" element={<CustomerService />} />
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/dashboard" element={<Dashboard />} />
        {/* <Route path="*" element={<Landing />} /> */}
      </Routes>
    </>
  );
}


